import { FiAlertOctagon, FiTrendingUp, FiPackage } from 'react-icons/fi';
import Modal from '../../Modal/Modal';
import { FormActions } from '../../ui';
import styles from './CreditLimitExceededModal.module.css';

interface CreditLimitExceededModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpgrade: () => void;
  creditsUsed: number;
  creditsLimit: number;
  currentPlan: string;
}

export function CreditLimitExceededModal({
  isOpen,
  onClose,
  onUpgrade,
  creditsUsed,
  creditsLimit,
  currentPlan,
}: CreditLimitExceededModalProps) {
  const overage = creditsUsed - creditsLimit;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="medium"
      showCloseButton={false}
      footer={
        <FormActions
          onCancel={onClose}
          cancelLabel="I'll Wait"
          submitLabel="Upgrade Plan Now"
          submitType="button"
          onSubmit={onUpgrade}
        />
      }
    >
      <div className={styles.iconWrapper}>
        <FiAlertOctagon className={styles.icon} />
      </div>

      <h2 className={styles.title}>Credit Limit Exceeded</h2>
      <p className={styles.message}>
        You've exceeded your monthly credit limit. Your services have been temporarily paused
        to prevent additional charges.
      </p>

      <div className={styles.stats}>
        <div className={styles.statItem}>
          <FiTrendingUp className={styles.statIcon} />
          <div className={styles.statContent}>
            <span className={styles.statLabel}>Credits Used</span>
            <span className={styles.statValue}>{creditsUsed.toLocaleString()}</span>
          </div>
        </div>
        <div className={styles.statItem}>
          <FiPackage className={styles.statIcon} />
          <div className={styles.statContent}>
            <span className={styles.statLabel}>Current Limit ({currentPlan})</span>
            <span className={styles.statValue}>{creditsLimit.toLocaleString()}</span>
          </div>
        </div>
        <div className={`${styles.statItem} ${styles.overage}`}>
          <div className={styles.statContent}>
            <span className={styles.statLabel}>Overage</span>
            <span className={styles.statValue}>+{overage.toLocaleString()}</span>
          </div>
        </div>
      </div>

      <div className={styles.solutions}>
        <h3>What can you do?</h3>
        <ul>
          <li><strong>Upgrade your plan</strong> to get more credits and resume services immediately</li>
          <li><strong>Wait until next month</strong> when your credits reset (not recommended)</li>
          <li><strong>Contact support</strong> if you believe this is an error</li>
        </ul>
      </div>
    </Modal>
  );
}

